<template>
  <div class="material-pictureBrowse-card left">
    <!-- 头部 -->
    <div class="material-detail-header clear">
      <div class="fl ml10 detail-text">图片详情</div>
      <div class="fr mr10 close cursor" @click="closeBrowse">
        <span class="iconfont"> &#xe6a0;</span>
      </div>
    </div>

    <!-- 标签 -->
    <div class="material-detail-tags ml20 clear">
      <div class="tags-left fl">
        <span>标签:</span>
        <template v-if="item.labelNameList">
          <span
            class="ml5 tag"
            v-for="tag in item.labelNameList.split('|')"
            :key="tag"
            >{{ tag
            }}<span @click="deleteTag(tag)" class="iconfont delete"
              >&#xe6a5;</span
            ></span
          >
        </template>
        <span @click="add" class="iconfont ml5 add">&#xe74a;</span>
      </div>
      <div class="tags-right fr">
        <span class="ml10">{{ item.addTime }}</span>
        <span class="iconfont ml10 icon">&#xe629;</span>
        <span class="mr10">收藏</span>
      </div>
    </div>
    <!-- 文章详情 -->
    <div class="material-picture-content ml20">
      <el-image :src="item.url" class="image">
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>
      <span class="iconfont pre cursor" @click="pre">
        &#xe68b;
      </span>
      <span class="iconfont next cursor" @click="next">&#xe68c;</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      number: 0
    };
  },
  computed: {
    ...mapState("material", ["tags"])
  },
  methods: {
    ...mapActions("material", ["ALabelBind"]),
    ...mapMutations("material", ["ASetDialogTagVisible"]),
    cancel() {
      alert("取消收藏" + this.item.id);
    },
    add() {
      this.ASetDialogTagVisible({
        dialogTagVisible: true,
        detailLableNameList: this.item.labelNameList,
        detailTag: this.item.labelNameList,
        detailId: this.item.favoriteImageId
      });
      //this.ASetDialogTagVisible(true);
      //alert("添加标签");
    },
    async deleteTag(tag) {
      var result = this.tags.filter(m => {
        return this.item.labelNameList.split("|").includes(m.labelName);
      });
      var tagsResult = result.filter(m => {
        return m.labelName != tag;
      });

      var labelIdList = tagsResult.map(m => m.labelId);

      var bindResult = await this.ALabelBind({
        labelIdList: labelIdList.join("|"),
        dataID: this.item.favoriteImageId,
        dataType: "image"
      });
      if (bindResult.errorCode === 0) {
        this.item.labelNameList = tagsResult.map(m => m.labelName).join("|");
      }
    },
    closeViewer() {},
    pre() {
      this.$emit("pre");
    },
    next() {
      this.$emit("next");
    },
    closeBrowse() {
      this.$emit("closeBrowse");
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/color";
@import "../../../assets/style/config";
@import "../../../assets/style/mixin";
//头部

.material-detail-header .detail-text {
  font-weight: bold;
  margin: 10px;
}
.material-detail-header .close {
  margin: 10px;
}
.material-detail-header {
  border-bottom: 1px solid #f1f1f1;
}
//标题
.material-detail-title h2 {
  margin-top: 15px;
  line-height: 1.5em;
}

//标签

.material-detail-tags {
  margin-top: 10px;
  font-size: 12px;
}

.material-detail-tags .tag {
  background-color: #f39117;
  padding: 1px 8px;
  border-radius: 10px;
  color: white;
  font-size: 12px;
}
.material-detail-tags .add {
  color: #f39117;
  cursor: pointer;
}
.material-detail-tags .tag .delete {
  margin-left: 3px;
  cursor: pointer;
  font-size: 12px;
}
.material-detail-tags .icon {
  color: #f39117;
}
//浏览图片
.material-picture-content {
  margin-top: 50px;
  position: relative;
}
.material-picture-content .image {
  position: relative;
}
.material-picture-content .pre {
  background-color: #727272;
  color: white;
  font-size: 20px;
  padding: 5px;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -15px;
}

.material-picture-content .next {
  background-color: #727272;
  color: white;
  font-size: 20px;
  padding: 5px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -15px;
}
</style>
